import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {State} from '@src/app/pages/Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {deleteFirmaZeitStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-del.actions';
import {editFirmaZeitenStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-edit.actions';
import {FeiertageFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/feiertage-form-dialog/feiertage-formdialog.component';
import {loadFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFeiertage.actions';
import {Observable} from 'rxjs';
import {FeiertagItem} from '@src/app/pages/Mitarbeiterverwaltung/feiertage.model';
import * as moment from 'moment';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  jahr: number;
  jahreszeit: number;
  tageszeit: number;
  arbeitstage: number;
}

@Component({
  selector: 'app-firmazeiten-formdialog',
  templateUrl: './firmazeiten-formdialog.component.html',
  styleUrls: ['./firmazeiten-formdialog.component.scss']
})


export class FirmaZeitFormdialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FirmaZeitFormdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private store: Store<{ mitarbeiterverwaltung: State }>,
              public dialog: MatDialog,
              )
  {
    dialogRef.disableClose = true;
    this.$feiertage = store.pipe(select((state) => state.mitarbeiterverwaltung.feiertage));
    this.firmaZeitForm.patchValue({
      jahr: data.jahr,
      jahreszeit: data.jahreszeit,
      tageszeit: data.tageszeit,
      arbeitstage: data.arbeitstage,
      id: data.id,
    });
  }

  public $feiertage: Observable<FeiertagItem[]>;

  public firmaZeitForm = new FormGroup({
    jahr: new FormControl('', [ Validators.maxLength(255) ]),
    jahreszeit: new FormControl('', [Validators.required, Validators.pattern('^[0-9,.]*$'), Validators.maxLength(255) ]),
    tageszeit: new FormControl('', [Validators.required, Validators.pattern('^[0-9,.]*$'), Validators.maxLength(255) ]),
    arbeitstage: new FormControl('', [Validators.required, Validators.pattern('^[0-9,.]*$'), Validators.maxLength(255) ])
  });

  public getErrorMessage(formField: string): string {
    const formControl = this.firmaZeitForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.pattern`;
    }
    return 'pages.mitarbeiterverwaltung.firmaDialog.err.generic';
  }

  public handleSubmitClick(): void{
    const item = this.firmaZeitForm.value;
    if ( isNaN( Number(sessionStorage.getItem('firmaZeitId'))) === false){
      item.id = sessionStorage.getItem('firmaZeitId');
    }else{
      item.id = this.data.id;
    }
    item.jahr = this.wandler(item.jahr);
    sessionStorage.setItem('firmaZeitId', null);
    this.store.dispatch(editFirmaZeitenStart({item}));
    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    if ( isNaN( Number(sessionStorage.getItem('firmaZeitId'))) === false){
      this.store.dispatch(deleteFirmaZeitStart({item: Number(sessionStorage.getItem('firmaZeitId'))}));
    }
    sessionStorage.setItem('firmaZeitId', null);
    this.dialogRef.close(true);
  }

  public addFeiertage(): void{
    let zeitId;
    if ( isNaN( Number(sessionStorage.getItem('firmaZeitId'))) === false){
       zeitId = sessionStorage.getItem('firmaZeitId');
    }
    else{
       zeitId = this.data.id;
    }
    console.log(zeitId);
    const dialogRef = this.dialog.open(FeiertageFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.firmaZeitenDialog.feiertagTitle',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
        firmaZeitId: zeitId,
      }
    });
  }

  ngOnInit(): void {
    let zeitId;
    if ( isNaN( Number(sessionStorage.getItem('firmaZeitId'))) === false){
      zeitId = sessionStorage.getItem('firmaZeitId');
    }
    else{
      zeitId = this.data.id;
    }

  //   this.store.dispatch(loadFeiertageStart({firmaZeitId: zeitId}));
  }

  /* Wandelt Datum um: Ohne Zeitzone und im richtigen Backendformat */
  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }




}
